export const SETTINGS = {
  // Three.js
  CAMERA: {
    FOV: 70,
    ASPECT: 1,
    NEAR: 0.1,
    FAR: 100,
  },
}